module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/002.c789fc38.png";